var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82778 16.0069L22.0621 29.2412C22.4515 29.6306 22.4515 30.2618 22.0621 30.6512C21.6711 31.0422 21.0366 31.0403 20.648 30.6469L6.91489 16.7474C6.52241 16.3501 6.52191 15.7112 6.91377 15.3134L20.6485 1.36848C21.0367 0.974389 21.6716 0.971979 22.0627 1.36311C22.4517 1.75215 22.4517 2.38291 22.0627 2.77196L8.82778 16.0069Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftL);
export default __webpack_public_path__ + "static/media/chevron-left-L.a3a1090f654d14d44de76db874424c23.svg";
export { ForwardRef as ReactComponent };